import React, { ReactNode } from 'react';

import styles from './TabSelector.module.scss';

export type TabOption<ValueType> = {
  value: ValueType,
  label: ReactNode,
} | 'separator';

export enum TabSelectorSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export default function TabSelector<ValueType = number>(
  props: {
    testId?: string,
    activeOption: ValueType | undefined,
    onSelected: (value: ValueType) => void,
    options: TabOption<ValueType>[],
    withoutMargin?: boolean,
    loading?: boolean,
    size?: TabSelectorSize,
    className?: string,
    isDisabled?: boolean,
  },
) {
  return (
    <div
      data-testid={props.testId}
      className={[
        styles.container,
        props.isDisabled ? styles.disabled : '',
        props.size ? styles[props.size.toLowerCase()] : styles.medium,
        props.withoutMargin ? styles.withoutMargin : '',
        props.loading ? styles.loading : '',
        props.className,
      ].join(' ')}
    >
      {props.options.map((option, index) => {
        if (option === 'separator') {
          return (<span className={styles.separator} key={`tab-${index}`}>|</span>)
        } else {
          const classes = [
            styles.tab,
            props.activeOption === option.value ? styles.active : '',
          ];

          return (
            <span
              className={classes.join(' ')}
              onClick={() => {
                if (!props.isDisabled) {
                  props.onSelected(option.value)
                }
              }}
              key={`tab-${index}`}
            >
              {option.label}
            </span>
          )
        }
      })}
    </div>
  );
}
